<template>
    <query-modal
        :success="status.isSuccess"
        :error="status.isError"
        :pending="status.isPending"
        @close="$emit('closeModal')"
    >
        <template #modal>
            <div class="flex justify-center flex-col gap-4">
                <h3 class="font-medium text-lg">
                    Опубликовать мероприятие {{ heading }}?
                </h3>
                <enter-button
                    class="mx-auto"
                    @click="accept"
                >
                    Опубликовать
                </enter-button>
            </div>
        </template>
        <template #success>
            <h3 class="font-medium text-lg">
                Мероприятие опубликовано
            </h3>
        </template>
        <template #error>
            <h3 class="font-medium text-lg">
                Ошибка. Попробуйте позже
            </h3>
        </template>
    </query-modal>
</template>

<script>
import QueryModal from "@/components/QueryModal";
import EnterButton from "@/components/Enter/Button";
import { changeEventCardId } from "@/api";

export default {
    name: "PublishEventCard",
    components: { QueryModal, EnterButton },
    props: {
        id: Number,
        heading: String
    },
    data() {
        return {
            status: {
                isSuccess: false,
                isError: false,
                isPending: false
            }
        }
    },
    methods: {
        accept() {
            const data = { data: { publishedAt: new Date().toISOString() } }
            return changeEventCardId(data, this.id)
                .then(response => {
                    this.$emit('accept')
                    this.status.isSuccess = true
                    return response
                })
                .catch(e => {
                    this.status.isError = true
                    console.log(e)
                })
        }
    }
}
</script>

<style scoped>

</style>